import { api } from "./api";

// The cookie already names the account, so the first data reads do not wait
// for /api/me. Each query uses its started read one time, then reads again.
const started = new Map<string, Promise<unknown>>();

export function startBootRequests(path: string) {
  // A public answer link has no session and reads no account data.
  if (path.startsWith("/answer/")) return;
  const reads: Record<string, () => Promise<unknown>> = {
    session: api.me,
    workflows: api.list,
    "runs:overview": api.runOverview,
    ...(path === "/runs" ? { "runs:list": () => api.runs() } : {}),
  };
  for (const [key, read] of Object.entries(reads)) {
    const promise = read();
    // The query that uses the read reports its error.
    promise.catch(() => {});
    started.set(key, promise);
  }
}

export function bootRequest<T>(key: string, read: () => Promise<T>): Promise<T> {
  const promise = started.get(key);
  if (!promise) return read();
  started.delete(key);
  return promise as Promise<T>;
}
